import axios from 'axios';
import getConfigs from '../configs'

let axiosConnection = null;

const initConnection = (configs) => {
  axiosConnection = axios.create({
    baseURL: configs.apiUrl,
    withCredentials: true,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'Content-Type': 'application/json'
    }
  });

  return axiosConnection;
}

const connectionPromise = getConfigs().then((configs) => axiosConnection || initConnection(configs));

const generator = (funcName) =>
  (...args) => connectionPromise.then((connection) => connection[funcName](...args));

export default {
  get: generator('get'),
  post: generator('post'),
  put: generator('put'),
  patch: generator('patch'),
  delete: generator('delete'),
  addResponseInterceptors(success, failure) {
    connectionPromise.then((connection) => connection.interceptors.response.use(success, failure));
  }
};
